import proofOfWork from '#components/generics/js/workers/proofOfWork.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'

export default contract({
  proofOfWork: array([
    proofOfWork
  ])
})
